<template>
  <b-dropdown class="lang-dropdown">
    <template v-slot:button-content>
      <div style="display: flex; align-items: center;">
        <b-img :src="selectedLang.flag" width="28" height="21" class="me-2"/>
        <div class="mx-1 text-body-1"> {{ selectedLang.text }}</div>
        <b-img :src="require('../../../assets/images/ic-dropdown.svg')" width="16" height="16" class="ms-1"/>
      </div>
    </template>
    <b-dropdown-item
        @click="changeLocale(languages[0].value)">
      <b-checkbox :class="'lang-cb ' + (checkVi ? 'lang-cb-highlight': '')" v-model="checkVi">
        <b-img :src="languages[0].flag" width="24" height="18" class="me-2"/>
        {{ languages[0].text }}
      </b-checkbox>
    </b-dropdown-item>
    <b-dropdown-item
        @click="changeLocale(languages[1].value)">
      <b-checkbox :class="'lang-cb ' + (checkEn ? 'lang-cb-highlight': '')" v-model="checkEn">
        <b-img :src="languages[1].flag" width="24" height="18" class="me-2"/>
        {{ languages[1].text }}
      </b-checkbox>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import store from "../../../store";
import {mapState} from "vuex";

export default {
  name: "ChangeLanguage",
  data: () => ({
    languages: [
      {
        text: "Tiếng Việt", 
        value: "vi", 
        flag: require('../../../assets/images/lang_vi.svg')
      },
      {
        text: "English", 
        value: "en", 
        flag: require('../../../assets/images/lang_en.svg')
      },
    ],
    checkVi: true,
    checkEn: false
  }),
  computed: {
    ...mapState(['locale']),
    selectedLang() {
      let selectedLang = this.languages.find(lang => lang.value === this.locale);
      if (selectedLang) {
        this.checkVi = selectedLang.value === 'vi'
        this.checkEn = selectedLang.value === 'en'
        return selectedLang
      }
      return this.languages[0]
    },
  },
  methods: {
    changeLocale(locale) {
      if (store.state.locale !== locale) {
        this.checkVi = locale === 'vi'
        this.checkEn = locale === 'en'
        store.dispatch("setLang", locale);
      }
    },
  }
};
</script>


<style scoped>

.lang-dropdown >>> .dropdown-menu {
  padding-left: 0;
}

.lang-dropdown >>> .dropdown-item.active, .dropdown-item:active {
  color: #fff;
  background-color: #E6F7FF;
}

.lang-dropdown >>> .dropdown-item:hover, .dropdown-item:focus {
  color: #1890FF;
  background-color: #E6F7FF;
}

.lang-dropdown >>> .btn-secondary:focus {
  box-shadow: none;
}

.lang-dropdown >>> .dropdown-toggle:after {
  display: none;
}

.lang-dropdown >>> .dropdown-toggle {
  color: #ffffff;
  background-color: rgba(0, 0, 0, 0);
  border-color: rgba(0, 0, 0, 0);
}

.lang-dropdown >>> .btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #ffffff;
  background-color: rgba(0, 0, 0, 0);
  border-color: rgba(0, 0, 0, 0);
}

.lang-cb {
  color: #000000;
}

.lang-cb:hover {
  color: #1890FF;
}

.lang-cb-highlight {
  color: #1890FF;
}

.lang-cb >>> .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #1890FF;
  background-color: #1890FF;
}

.lang-cb >>> .custom-control-label::before {
  border-color: #D9D9D9;
}

</style>